import React, { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './Toast.module.css';

interface ToastProps {
    className?: string;
}

export const Toast: FC<PropsWithChildren<ToastProps>> = ({ children, className }) => (
    <div className={classnames(styles.root, className)}>{children}</div>
);
